import React from "react";
import { Grid, Typography, Stack } from "@mui/material";
import { Link as DomLink } from "react-router-dom";

const PendantsTab = ({ links }) => {
  return (
    <Grid container>
      <Grid item xs={3}>
        <Stack direction="column" className="navbar-stack">
          <Typography className="navbar-text">Shop by Metal Color</Typography>
          {links.PendantsLinks.MetalColor.map((link, index) => (
            <DomLink
              key={index}
              to={{
                pathname: "/products/Pendants",
                state: {
                  Material: link.materials,
                },
              }}
              onClick={() => {
                if (window.location.pathname === "/products/Pendants") {
                  window.location.reload();
                }
              }}
            >
              {link.label}
            </DomLink>
          ))}
          <Typography className="navbar-text" marginTop={"2rem"}>
            Shop by Bail Type
          </Typography>
          {links.PendantsLinks.PendantsStyle.map((link, index) => (
            <DomLink
              key={index}
              to={{
                pathname: "/products/Pendants",
                state: {
                  BailStyle: link.type,
                },
              }}
              onClick={() => {
                if (window.location.pathname === "/products/Pendants") {
                  window.location.reload();
                }
              }}
            >
              {link.label}
            </DomLink>
          ))}
        </Stack>
      </Grid>
      <Grid item xs={3}>
        <Typography className="navbar-text">Shop by Shape</Typography>
        <Stack direction="column" className="navbar-stack">
          {links.PendantsLinks.PendantsShape.map((link, index) => (
            <DomLink
              key={index}
              to={{
                pathname: "/products/Pendants",
                state: {
                  Shape: link.shape,
                },
              }}
              onClick={() => {
                if (window.location.pathname === "/products/Pendants") {
                  window.location.reload();
                }
              }}
            >
              {link.label}
            </DomLink>
          ))}
        </Stack>
      </Grid>
      <Grid item xs={3}>
        <Stack direction="column" className="navbar-stack">
          <Typography className="navbar-text">Shop by Prong</Typography>
          {links.PendantsLinks.PendantsProngs.map((link, index) => (
            <DomLink
              key={index}
              to={{
                pathname: "/products/Pendants",
                state: {
                  Prongs: link.type,
                },
              }}
              onClick={() => {
                if (window.location.pathname === "/products/Pendants") {
                  window.location.reload();
                }
              }}
            >
              {link.label}
            </DomLink>
          ))}
          <Typography className="navbar-text" marginTop={"2rem"}>
            Shop by Advanced Options
          </Typography>
          {links.PendantsLinks.PendantsAdvanceOptions.map((link, index) => (
            <DomLink
              key={index}
              to={{
                pathname: "/products/Pendants",
                state: {
                  AdvancedOptions: link.type,
                },
              }}
              onClick={() => {
                if (window.location.pathname === "/products/Pendants") {
                  window.location.reload();
                }
              }}
            >
              {link.label}
            </DomLink>
          ))}
        </Stack>
      </Grid>
      <Grid item xs={3}>
        <Typography className="navbar-text">Additional Info</Typography>
        <Stack direction={"column"} className="navbar-stack">
          {links.AdditionalInfo.map((link, index) => (
            <DomLink key={index} to={{ pathname: link.path }}>
              {link.label}
            </DomLink>
          ))}
        </Stack>
      </Grid>
    </Grid>
  );
};

export default PendantsTab;
